<!-- UpdatedTable.svelte -->
<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .text-overline {
    @include mixins.overline();
    @include colors.color(black_90);
  }

  .text-body-2 {
    @include mixins.body2();
    @include colors.color(black_90);
  }

  .source {
    display: block;
    max-width: utils.in_rem(130px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .no-data {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    flex-grow: 1;
  }
</style>

<script>
  import Tooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/Tooltip.svelte";
  import Table from "@sourcewhale/shared/svelte-design-system/components/molecules/Table/Table.svelte";
  import TBODY from "@sourcewhale/shared/svelte-design-system/components/molecules/Table/TBODY.svelte";
  import TD from "@sourcewhale/shared/svelte-design-system/components/molecules/Table/TD.svelte";
  import THEAD from "@sourcewhale/shared/svelte-design-system/components/molecules/Table/THEAD.svelte";
  import TR from "@sourcewhale/shared/svelte-design-system/components/molecules/Table/TR.svelte";
  import { clicksGroupedStore, opensGroupedStore } from "../stores";
  import { formatActivityDate, formatActivityTime } from "../utils";
  import NoEngagementData from "./NoEngagementData.svelte";

  export let tableType = "opens";

  const TABLE_HEADERS = {
    opens: { title: "SUBJECT", name: "OPENS" },
    clicks: { title: "LINK", name: "CLICKS" },
  };

  $: currentHeaders = TABLE_HEADERS[tableType];
  $: dataStore = tableType === "opens" ? opensGroupedStore : clicksGroupedStore;
  $: meta = dataStore.meta;
  $: skeleton = $meta.fetching || !$meta.firstFetchDone;
  $: rowsData = skeleton
    ? Array.from({ length: 5 }).map(() => ({
        stepNumber: "Loading",
        timestamp: 1,
        link: "Loading...",
        source: "Loading...",
        total: "Loading...",
      }))
    : $dataStore || [];
  $: noData = !rowsData.length;
</script>

<!-- Place scroll bar in table so that header remains fixed -->
<div style={noData ? "" : "overflow: auto;"}>
  <Table>
    <THEAD>
      <TR>
        <TD>
          {currentHeaders.title}
        </TD>
        <TD>Step</TD>
        <TD>Date</TD>
        <TD>Time</TD>
        <TD>
          {currentHeaders.name}
        </TD>
      </TR>
    </THEAD>
    <TBODY>
      {#each rowsData as rowData}
        <TR>
          <TD>
            {#if rowData?.source}
              <!-- Display full source in tooltip -->
              <Tooltip
                placement="right"
                let:onmouseenter
                let:onmouseleave
                let:onblur
                let:onfocus
              >
                <span slot="tooltip">{rowData.source}</span>
                <span
                  class="text-body-2 source"
                  class:skeleton
                  on:mouseenter={onmouseenter}
                  on:mouseleave={onmouseleave}
                  on:focus={onfocus}
                  on:blur={onblur}
                  role="button"
                  tabindex="-1"
                >
                  {rowData.source}
                </span>
              </Tooltip>
            {/if}
          </TD>
          <TD>
            {#if rowData.stepNumber}
              <span class="text-body-2" class:skeleton
                >{rowData.stepNumber}</span
              >
            {/if}
          </TD>
          <TD>
            {#if rowData.timestamp}
              <span class="text-body-2" class:skeleton
                >{formatActivityDate(rowData.timestamp)}</span
              >
            {/if}
          </TD>
          <TD>
            {#if rowData.timestamp}
              <span class="text-body-2" class:skeleton
                >{formatActivityTime(rowData.timestamp)}</span
              >
            {/if}
          </TD>
          <TD>
            {#if rowData.total}
              <span class="text-body-2" class:skeleton>{rowData.total}</span>
            {/if}
          </TD>
        </TR>
        <!-- TODO: Refactor/fix/update -->
        {#each rowData.history || [] as historyRow}
          <TR isChild={true}>
            <TD />
            <TD />
            <TD>
              {#if historyRow?.timestamp}
                <span class="text-body-2" class:skeleton
                  >{formatActivityDate(historyRow.timestamp)}</span
                >
              {/if}
            </TD>
            <TD
              >{#if historyRow?.timestamp}
                <span class="text-body-2" class:skeleton
                  >{formatActivityTime(historyRow.timestamp)}</span
                >
              {/if}</TD
            >
            <TD />
          </TR>
        {/each}
      {/each}
    </TBODY>
  </Table>
</div>
<!-- Append at the end here so it is vertically centred in the modal -->
{#if noData}
  <div class="no-data">
    <NoEngagementData />
  </div>
{/if}
